export const FULL_DEAL_MOBILE_APP_LINKS = {
  FROM_MODAL_OFFER: 'https://sravni.go2cloud.org/aff_c?offer_id=2443&aff_id=2&url_id=13581',
  FROM_REFERAL_VITRINA: 'https://sravni.go2cloud.org/aff_c?offer_id=2443&aff_id=2&url_id=13580',
  FROM_LANDING: 'https://sravni.go2cloud.org/aff_c?offer_id=2443&aff_id=2&url_id=13579',
};

export const FULL_DEAL_WEB_TO_WEB_LINKS = {
  FROM_MODAL_OFFER: 'https://sravni.go2cloud.org/aff_c?offer_id=2443&aff_id=2&url_id=13326',
  FROM_REFERAL_VITRINA: 'https://sravni.go2cloud.org/aff_c?offer_id=2443&aff_id=2&url_id=13319',
  FROM_LANDING: 'https://sravni.go2cloud.org/aff_c?offer_id=2443&aff_id=2&url_id=13320',
};

export const FULL_DEAL_WEB_TO_WEB_SOURCE = {
  FROM_MODAL_OFFER: 'ref_offer_modal_window_500rub_web_to_web',
  FROM_REFERAL_VITRINA: 'header_calculator_web_to_web',
  FROM_LANDING: 'landing_calculator_web_to_web',
};

export const FULL_DEAL_MOBILE_APP_SOURCE = {
  FROM_MODAL_OFFER: 'ref_offer_modal_window_500rub_web_to_app',
  FROM_REFERAL_VITRINA: 'header_calculator_web_to_app',
  FROM_LANDING: 'landing_calculator_web_to_app',
};
